// init.js
jQuery(function ($) {
  $('.uni_slots__swiper').each(function () {
    const $wrap = $(this);

    new Swiper($wrap[0], {
      slidesPerView: Number($wrap.data('count')) || 1,
      spaceBetween: Number($wrap.data('space')) || 0,
      breakpoints: {
        320:  { slidesPerView: 2, spaceBetween: 16 },
        768:  { slidesPerView: (Number($wrap.data('count')) || 1) - 2, spaceBetween: 16 },
        1124: { slidesPerView: (Number($wrap.data('count')) || 1) - 1, spaceBetween: 16 },
        1366: { slidesPerView: Number($wrap.data('count')) || 1, spaceBetween: Number($wrap.data('space')) || 0 },
      },
      navigation: {
        nextEl: $wrap.find('.swiper-button-next').get(0),
        prevEl: $wrap.find('.swiper-button-prev').get(0),
      },
    });
  });
});
